import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Article Body Background customisation
 * Returns body container background styling
 */
export const useArticleBodyBackgroundCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.ARTICLE,
    sectionKey: PUI.ARTICLES_SECTION_KEYS.BODY_BACKGROUND,
    blockKey: PUI.ARTICLES_BLOCK_KEYS.BODY_SECTION,
  });

  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);

  return {
    isVisible,
    backgroundColor,
  };
};

/**
 * Composable for Article Content customisation
 * Returns article content (title and body) styling
 */
export const useArticleContentCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.ARTICLE,
    sectionKey: PUI.ARTICLES_SECTION_KEYS.ARTICLE_CONTENT,
    blockKey: PUI.ARTICLES_BLOCK_KEYS.BODY_SECTION,
  });

  const labelColor = getField(PUI.COMMON_FIELD_KEYS.LABEL_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    labelColor,
    textColor,
  };
};
